import React from 'react';
import {RawMarkupComponent} from '../components/base';
import {ToolbarFormatMenu,
ToolbarEditMenu,
ToolbarColorPicker,
ToolbarMenu,
ToolbarLink,
ToolbarSeparator,
ToolbarButton,
ToolbarButtonGroup,
EditorToolbar,
ToolbarDefaultButtonGroup,
ToolbarTinyButtonGroup,
ToolbarMinimalButtonGroup} from './toolbars';

import {MediaManagerController} from './media-manager';
import {MDCFormSwitch} from '../components/mdc-components';
import {YoutubeDialog} from './dialogs';
import Word from './word';


export const ContentPlaceholder={
    generate:function(id,url,label,css){
       return '<div data-content-placeholder="' + id + '" data-url="' + url + '" class="cms-placeholder-card ' + css + '">' +
         '<div class="card__image"><span>' + label + '</span></div>' +
         '<div class="card__content">' +
           '<div class="card__heading"></div>' +
           '<div class="card__paragraph"></div>' +
         '</div>' +
       '</div>';
    }
};

export class ContentEditable extends React.Component{
     constructor(props){
        super(props);
        this.range=null;
        this.codeView=false;
     }

     componentDidMount() {
        if(this.props.active) this.editor.setAttribute('contenteditable',true);
     }

     componentDidUpdate() {
        if(this.props.active) this.editor.setAttribute('contenteditable',true);
     }

     rawMarkup(body){
      return { __html: body };
     }

     onFocus(event){
        this.editor.classList.add('focus');
        if(this.props.onEditorFocus) this.props.onEditorFocus(event);
     }

     onBlur(event){
        this.editor.classList.remove('focus');
        if(this.props.onEditorBlur) this.props.onEditorBlur(event);
        if(this.props.onChange){
            var content=this.getContent();
            this.props.onChange(content);
        }
     }

     executeCommand(name,value){
        document.execCommand(name, false, value);
        this.editor.focus();
     }

     setFocus(){
        this.editor.focus();
     }

     removeFocus(){
        this.editor.blur();
     }

     getRange(){
        if(this.range) return this.range;
        else return window.getSelection().getRangeAt(0).cloneRange();
     }

     setRange(){
        this.range=window.getSelection().getRangeAt(0).cloneRange();
     }

     resetRange(){
        this.range=null;
     }

     insertContent(html){
         var sel,range;
         var range=this.getRange();
         range.deleteContents();
         var frag = range.createContextualFragment(html);
         range.insertNode(frag);
         this.resetRange();
     }

     cleanWord(str){
         str = str.replace(/<o:p>\s*<\/o:p>/g, "") ;
         str = str.replace(/<o:p>.*?<\/o:p>/g, "&nbsp;") ;
         str = str.replace( /\s*mso-[^:]+:[^;"]+;?/gi, "" ) ;
         str = str.replace( /\s*MARGIN: 0cm 0cm 0pt\s*;/gi, "" ) ;
         str = str.replace( /\s*MARGIN: 0cm 0cm 0pt\s*"/gi, "\"" ) ;
         str = str.replace( /\s*TEXT-INDENT: 0cm\s*;/gi, "" ) ;
         str = str.replace( /\s*TEXT-INDENT: 0cm\s*"/gi, "\"" ) ;
         str = str.replace( /\s*TEXT-ALIGN: [^\s;]+;?"/gi, "\"" ) ;
         str = str.replace( /\s*PAGE-BREAK-BEFORE: [^\s;]+;?"/gi, "\"" ) ;
         str = str.replace( /\s*FONT-VARIANT: [^\s;]+;?"/gi, "\"" ) ;
         str = str.replace( /\s*tab-stops:[^;"]*;?/gi, "" ) ;
         str = str.replace( /\s*tab-stops:[^"]*/gi, "" ) ;
         str = str.replace( /\s*face="[^"]*"/gi, "" ) ;
         str = str.replace( /\s*face=[^ >]*/gi, "" ) ;
         str = str.replace( /\s*FONT-FAMILY:[^;"]*;?/gi, "" ) ;
         str = str.replace(/<(\w[^>]*) class=([^ |>]*)([^>]*)/gi, "<$1$3") ;
         str = str.replace( /<(\w[^>]*) style="([^\"]*)"([^>]*)/gi, "<$1$3" ) ;
         str = str.replace( /\s*style="\s*"/gi, '' ) ; 
         str = str.replace( /<SPAN\s*[^>]*>\s*&nbsp;\s*<\/SPAN>/gi, '&nbsp;' ) ; 
         str = str.replace( /<SPAN\s*[^>]*><\/SPAN>/gi, '' ) ; 
         str = str.replace(/<(\w[^>]*) lang=([^ |>]*)([^>]*)/gi, "<$1$3") ; 
         str = str.replace( /<SPAN\s*>(.*?)<\/SPAN>/gi, '$1' ) ; 
         str = str.replace( /<FONT\s*>(.*?)<\/FONT>/gi, '$1' ) ;
         str = str.replace(/<\\?\?xml[^>]*>/gi, "") ; 
         str = str.replace(/<\/?\w+:[^>]*>/gi, "") ; 
         str = str.replace( /<H\d>\s*<\/H\d>/gi, '' ) ;
         str = str.replace( /<H1([^>]*)>/gi, '' ) ;
         str = str.replace( /<H2([^>]*)>/gi, '' ) ;
         str = str.replace( /<H3([^>]*)>/gi, '' ) ;
         str = str.replace( /<H4([^>]*)>/gi, '' ) ;
         str = str.replace( /<H5([^>]*)>/gi, '' ) ;
         str = str.replace( /<H6([^>]*)>/gi, '' ) ;
         str = str.replace( /<\/H\d>/gi, '<br>' ) ; //remove this to take out breaks where Heading tags were 
         str = str.replace( /<(U|I|STRIKE)>&nbsp;<\/\1>/g, '&nbsp;' ) ;
         str = str.replace( /<(B|b)>&nbsp;<\/\b|B>/g, '' ) ;
         str = str.replace( /<([^\s>]+)[^>]*>\s*<\/\1>/g, '' ) ;
         str = str.replace( /<([^\s>]+)[^>]*>\s*<\/\1>/g, '' ) ;
         str = str.replace( /<([^\s>]+)[^>]*>\s*<\/\1>/g, '' ) ;
         //some RegEx code for the picky browsers
         var re = new RegExp("(<P)([^>]*>.*?)(<\/P>)","gi") ;
         str = str.replace( re, "<div$2</div>" ) ;
         var re2 = new RegExp("(<font|<FONT)([^*>]*>.*?)(<\/FONT>|<\/font>)","gi") ; 
         str = str.replace( re2, "<div$2</div>") ;
         str = str.replace( /size|SIZE = ([\d]{1})/g, '' ) ;
         return str;
     }

     cleanContent(str){
         var html=this.cleanWord(str);
         html = html.replace(/<(\/)*(\\?xml:|meta|link|span|font|del|ins|st1:|[ovwxp]:)((.|\s)*?)>/gi, ''); // Unwanted tags
         html = html.replace(/(class|style|type|start)=("(.*?)"|(\w*))/gi, ''); // Unwanted sttributes
         html = html.replace(/<style(.*?)style>/gi, '');   // Style tags
         html = html.replace(/<script(.*?)script>/gi, ''); // Script tags
         html = html.replace(/<!--(.*?)-->/gi, '');        // HTML comments
         return html;
     }

     removeFormatting(){
        var content=this.getContent();
        content=this.cleanContent(content);
        this.setContent(content);
     }

     paste(str){
         var html=this.cleanContent(str);
         this.insertContent(html);
     }

     pasteFromWord(str){
        var html=this.cleanWord(str);
         this.insertContent(html);
     }

     pasteRaw(str){
        this.insertContent(html);
     }

     extractText(element){
        if (element.innerHTML) { return element.innerHTML; }
        var oContent = document.createRange();
        if(element.firstChild){
           oContent.selectNodeContents(element.firstChild);
           return oContent.toString();
        }else{
            return "";
        }
     }

     extractFromPreNode(element){
        var oContent = document.createRange();
        oContent.selectNodeContents(element.firstChild);
        return oContent.toString(); 
     }

     saveSelection() {
         if (window.getSelection) {
             sel = window.getSelection();
             if (sel.getRangeAt && sel.rangeCount) {
                 return sel.getRangeAt(0);
             }
         } else if (document.selection && document.selection.createRange) {
             return document.selection.createRange();
         }
         return null;
     }

     restoreSelection(range) {
         var sel;
         if (range) {
             if (window.getSelection) {
                 sel = window.getSelection();
                 sel.removeAllRanges();
                 sel.addRange(range);
             } else if (document.selection && range.select) {
                 range.select();
             }
         }
     }

     setContent(html){
        this.editor.innerHTML=html;
     }

     /* Wrap the current selection in <span class="...">. execCommand has no
        equivalent (formatblock only takes tag names), so this backs the
        optional custom entries in the Format menu. No-op when nothing is
        selected. */
     applyClassToSelection(className){
        if(!className) return;
        var sel=window.getSelection();
        if(!sel || !sel.rangeCount) return;
        var range=sel.getRangeAt(0);
        if(range.collapsed) return;
        var span=document.createElement('span');
        span.className=className;
        try{
            range.surroundContents(span);
        }catch(e){
            /* selection crosses element boundaries — extract then re-insert */
            span.appendChild(range.extractContents());
            range.insertNode(span);
        }
        sel.removeAllRanges();
        if(this.props.onChange) this.props.onChange(this.getContent());
     }

     getContent(){
        if(!this.editor) return null;
        if(this.codeView) return this.extractFromPreNode(this.editor); 
        return this.extractText(this.editor);
     }

     getSelectedHtml() {
         var html = "";
         if (typeof window.getSelection != "undefined") {
             var sel = window.getSelection();
             if (sel.rangeCount) {
                 var container = document.createElement("div");
                 for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                     container.appendChild(sel.getRangeAt(i).cloneContents());
                 }
                 html = container.innerHTML;
             }
         } else if (typeof document.selection != "undefined") {
             if (document.selection.type == "Text") {
                 html = document.selection.createRange().htmlText;
             }
         }
         return html;
     }

     setDocumentMode(){
        var isSourceMode=false;
        console.log(this.sourceMode);
        if(!this.sourceMode){
            this.sourceMode=true;
            isSourceMode=true;
        }else{
            this.sourceMode=false;
            isSourceMode=false;
        } 
        this.codeView=isSourceMode; 
        if (isSourceMode) {
            var oContent = document.createTextNode(this.editor.innerHTML), oPre = document.createElement("pre");
            this.editor.innerHTML = "";
            this.editor.contentEditable = false;
            oPre.className = "html-source";
            oPre.id = "html-source-" + this.editor.id;
            oPre.onblur = this.editor.onblur;
            oPre.contentEditable = true;
            oPre.appendChild(oContent);
            this.editor.appendChild(oPre);
            document.execCommand("defaultParagraphSeparator", false, "div");
        } else {
            this.editor.innerHTML = this.extractFromPreNode(this.editor);
            this.editor.contentEditable = true;
        }
        //this.editor.focus();
     }

     onChange(event){
     }

     render(){
        var id=this.props.id;
        if(!id) id='editor';
        var content=this.props.content;
        if(!content) content='';
        var cls='rich-editor';
        if(this.props.active){
            cls+=' active';
            return(
                <div className={cls} 
                  id={id} 
                  ref={(ref) => this.editor = ref} 
                  onFocus={this.onFocus.bind(this)} 
                  onBlur={this.onBlur.bind(this)} 
                  tabIndex="0" 
                  dangerouslySetInnerHTML={this.rawMarkup(content)} 
                />
            );
        }else{
            return(
               <div className={cls} 
                 dangerouslySetInnerHTML={this.rawMarkup(content)} 
                 ref={(ref) => this.editor = ref} 
               />
            );
        }
     }
}

export class RichEditorComponent extends React.Component{
    constructor(props){
        super(props);
    }

    onButtonClick(data){
        if(data.command==='removeFormat'){
            this.editor.removeFormatting();
        }else{
            this.editor.executeCommand(data.command, data.value);
        }
    }

    onWordFormatClick(event){
        this.onClean();
    }

    onMenuSelected(event){
        var item=event.detail.item;
        var command=item.dataset.command;
        var value=item.dataset.value;
        if(command==='formatclass'){
            this.editor.applyClassToSelection(value);
            return;
        }
        this.editor.executeCommand(command,value);
    }

    onAddHorizontalLine(event){
        var html="<hr/>"
        this.editor.insertContent(html);
    }

    onAddReadMore(){
        var html='<div class="read-more">[--READ MORE--]</div>';
        this.editor.insertContent(html);
    }

    onHtmlCheckedChange(checked){
        this.editor.setDocumentMode(checked);
    }

    onDialogAccept(html){
       this.editor.insertContent(html);
    }

    onColorSelect(color){
       this.editor.executeCommand('forecolor',color);
    }

    onSaveSelection(){
        this.editor.setRange();
    }

    onCreateLink(url){
        var range=this.editor.getRange();
        this.editor.restoreSelection(range);
        this.editor.executeCommand('createlink',url);
        this.editor.resetRange();
    }

    onMediaSelected(event){
        var item=event.detail.item;
        var command=item.dataset.command;
        this.editor.setRange();
    }

    onCutSelection(){
        this.editor.executeCommand('cut');
    }

    onCopySelection(){
        this.editor.executeCommand('copy');
    }

    onClean(){
        console.log('clean');
        var range=this.editor.getRange();
        var html=this.editor.getSelectedHtml();
        html=Word.clean(html);
        this.editor.paste(html);
    }

    onPasteRaw(){
        this.editor.executeCommand('cut');
    }

    onToolbarActive(){
        this.editorContainer.classList.add('toolbar-active');
    }

    onToolbarHide(){
        this.editorContainer.classList.remove('toolbar-active');
    }

    getContent(){
        return this.editor.getContent();
    }
}

export class RichEditor extends React.Component{
    constructor(props){
         super(props);
    }

    onEditorFocus(event){
        if(this.props.onEditorFocus) this.props.onEditorFocus(event);
    }

    onEditorBlur(event){
        if(this.props.onEditorBlur) this.props.onEditorBlur(event);
        if(this.props.onChange){
            var content=this.getContent();
            this.props.onChange(content);
        }
    }

    componentWillUpdate(){
       this.content=this.editor.getContent();
    }

    getContent(){
        return this.editor.getContent();
    }

    render(){
        var propContent=this.props.content;
        var content=this.content;
        if(!content) content=propContent;
        var cls='rich-editor-container';
        if(this.props.cls) cls+= ' ' + this.props.cls;
        if(this.props.active){
           cls+=' active'
           return(
               <div className={cls} tabIndex="0" ref={(ref) => this.editorContainer = ref}>
                   {this.props.children}
                   <ContentEditable 
                     ref={(ref) => this.editor = ref} 
                     onEditorFocus={this.onEditorFocus.bind(this)} 
                     onEditorBlur={this.onEditorBlur.bind(this)} 
                     content={content} 
                     active={this.props.active}
                     cls={this.props.cls} 
                     onChange={this.props.onChange}
                   />
               </div>
           );
        }else{
           return(
               <div className={cls} ref={(ref) => this.editorContainer = ref}>
                   <ContentEditable 
                     ref={(ref) => this.editor = ref} 
                     content={content} 
                     active={this.props.active} 
                     cls={this.props.cls} 
                   />
               </div>
           );
        }
    }
}

//full toolbar rich editor
export class ContentRichEditor extends RichEditorComponent{
    constructor(props){
        super(props);
    }

    componentDidMount(){
        this.editor=this.richEditor.editor;
        this.editorContainer=this.richEditor.editorContainer;
    }

    componentDidUpdate(){
        this.editor=this.richEditor.editor;
        this.editorContainer=this.richEditor.editorContainer;
    }

    onEditMenuSelected(event){
        var item=event.detail.item;
        var command=item.dataset.command;
        this.editor.setRange();
        switch(command){
            case 'copy':
              this.onCopySelection();
              break;
            case 'cut':
              this.onCutSelection();
              break;
            case 'clean':
              this.onClean();
              break;
        }
    }

    onMediaSelected(event){
        var item=event.detail.item;
        var command=item.dataset.command;
        this.editor.setRange();
        switch(command){
            case 'image':
              this.imageCommand=command;
              this.mediaController.mode='select';
              this.mediaController.show();
              break;
            case 'images-2':
              this.imageCommand=command;
              this.mediaController.mode='multi-select';
              this.mediaController.show();
              break;
            case 'images-3':
              this.imageCommand=command;
              this.mediaController.mode='multi-select';
              this.mediaController.show();
              break;
            case 'video':
              this.youtubeDialog.show();
              break;
        }
    }

    onEditorFocus(event){
        this.toolbar.setFocus();
    }

    onEditorBlur(event){
        this.toolbar.removeFocus();
    }

    onToolbarHide(){
        super.onToolbarHide();
        this.toolbar.hide();
    }

    onAddImage(event){
        this.imageCommand='image-full-width';
        this.mediaController.mode='select';
        this.mediaController.show();
    }

    onFilesSelected(files){
       var command=this.imageCommand;
       this.imageCommand=null; 
       switch(command){
           case 'image-full-width':
             this.insertFullWidthImage(files[0]);
             break;
           case 'image':
             this.insertImage(files[0]);
             break;
           case 'image-placeholder':
             this.insertPlaceholder(files[0]);
             break;
           case 'images-2':
             this.insert2Images(files);
             break;
           case 'images-3':
             this.insert3Images(files);
             break;
       }
    }

    insertImage(file){
        if(!file) return;
        var html='<div class="post-image"><figure><img src="' + file.url + '" />';
        if(file.title) html+='<figcaption>' + file.title + '</figcaption>';
        html+='</figure></div>';
        this.editor.insertContent(html);
    }

    insertFullWidthImage(file){
        if(!file) return;
        var html='<div class="post-full-width-image"><figure><img src="' + file.url + '" />';
        if(file.title) html+='<figcaption>' + file.title + '</figcaption>';
        html+='</figure></div>';
        this.editor.insertContent(html);
    }

    insert2Images(files){
        var length=files.length;
        if(length < 1) return;
        if(length<2) length=1;
        else length=2;
        var html='<div class="post-two-images">';
        for(var i=0;i<length;i++){
            var file=files[i];
             html+='<figure><img src="' + file.url + '" />';
             if(file.title) html+='<figcaption>' + file.title + '</figcaption>';
             html+='</figure>';
        }
        html+='</div>'
        this.editor.insertContent(html);
    }

    insert3Images(files){
       var length=files.length;
       if(length < 1) return;
       if(length<2) length=1;
       else if(length < 3) length=2;
       else length=3;
       var html='<div class="post-three-images">';
       for(var i=0;i<length;i++){
           var file=files[i];
            html+='<figure><img src="' + file.url + '" />';
            if(file.title) html+='<figcaption>' + file.title + '</figcaption>';
            html+='</figure>';
       }
       html+='</div>'
       this.editor.insertContent(html);
    }

    onFilesCancel(){
        this.imageSelectionType=null; 
    }

    render(){
        var cls=this.props.cls;
        
        return(
            <RichEditor 
               active={this.props.active} 
               content={this.props.content}  
               ref={(ref) => this.richEditor = ref} 
               onEditorFocus={this.onEditorFocus.bind(this)}
               onEditorBlur={this.onEditorBlur.bind(this)} 
               onChange={this.props.onChange} 
               cls={cls} 
               >
               <MediaManagerController 
                  postUrl={this.props.filePostUrl}
                  data={this.props.mediaManagerData} 
                  ref={(ref) => this.mediaController = ref}
                  onFilesSelected={this.onFilesSelected.bind(this)}
                  onCancel={this.onFilesCancel.bind(this)}
                />
                <YoutubeDialog 
                  ref={(ref) => this.youtubeDialog = ref} 
                  onDialogAccept={this.onDialogAccept.bind(this)}  
                />
               <EditorToolbar onToolbarActive={this.onToolbarActive.bind(this)} ref={(ref) => this.toolbar = ref} disableAlwaysVisible={this.props.disableAlwaysVisibleToolbar}>
                   <ToolbarButtonGroup>
                      <ToolbarFormatMenu onMenuSelected={this.onMenuSelected.bind(this)} customFormats={this.props.customFormats} />
                      <ToolbarEditMenu onMenuSelected={this.onEditMenuSelected.bind(this)} />
                      <ToolbarMenu label="Media" onMenuSelected={this.onMediaSelected.bind(this)} id="media">
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="image">Add Image</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="images-2">Add 2 Images</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="images-3">Add 3 Images</li>
                        <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="video">Add Youtube Video</li>
                      </ToolbarMenu>
                      <ToolbarSeparator />
                      <ToolbarColorPicker onColorSelect={this.onColorSelect.bind(this)} addColors="#a6978a" />
                      <ToolbarLink onDialogAccept={this.onCreateLink.bind(this)} onSaveSelection={this.onSaveSelection.bind(this)} />
                      <ToolbarButton icon="photo_library" hint="Add Image" onButtonClick={this.onAddImage.bind(this)} />
                      <ToolbarButton icon="remove" hint="Horizontal line" onButtonClick={this.onAddHorizontalLine.bind(this)} />
                      <ToolbarSeparator />
                      <MDCFormSwitch label="html" fieldCls="margin-left-auto" onCheckedChange={this.onHtmlCheckedChange.bind(this)} />
                   </ToolbarButtonGroup>
                   <hr className="horizontal-separator" />
                   <ToolbarDefaultButtonGroup onButtonClick={this.onButtonClick.bind(this)} onToolbarHide={this.onToolbarHide.bind(this)} />
               </EditorToolbar>
            </RichEditor>
        )
    }
}

// minimal toolbar rich editor
export class TinyRichEditor extends RichEditorComponent{
    constructor(props){
        super(props);
    }

    componentDidMount(){
        this.editor=this.richEditor.editor;
        this.editorContainer=this.richEditor.editorContainer;
    }

    componentDidUpdate(){
        this.editor=this.richEditor.editor;
        this.editorContainer=this.richEditor.editorContainer;
    }

    onEditorFocus(event){
        this.toolbar.setFocus();
    }

    onEditorBlur(event){
        this.toolbar.removeFocus();
    }

    onToolbarHide(){
        super.onToolbarHide();
        this.toolbar.hide();
    }


    render(){
        var cls='single-toolbar no-min-height';
        if(this.props.disableSticky) cls+= ' sticky-disabled';
        if(this.props.cls) cls+=' ' + this.props.cls;
        return(
            <RichEditor 
               active={this.props.active} 
               content={this.props.content}  
               ref={(ref) => this.richEditor = ref} 
               onEditorFocus={this.onEditorFocus.bind(this)}
               onEditorBlur={this.onEditorBlur.bind(this)} 
               cls={cls} 
               onChange={this.props.onChange}
               >
               <EditorToolbar 
                   onToolbarActive={this.onToolbarActive.bind(this)} 
                   ref={(ref) => this.toolbar = ref} 
                   disableAlwaysVisible={this.props.disableAlwaysVisibleToolbar}
                >
                   <ToolbarTinyButtonGroup 
                      onButtonClick={this.onButtonClick.bind(this)} 
                      onWordFormatClick={this.onWordFormatClick.bind(this)} 
                      onToolbarHide={this.onToolbarHide.bind(this)} 
                      onColorSelect={this.onColorSelect.bind(this)} 
                      addColors={this.props.addColors} 
                      onDialogAccept={this.onDialogAccept.bind(this)} 
                      onSaveSelection={this.onSaveSelection.bind(this)} 
                      onCreateLink={this.onCreateLink.bind(this)}
                    />
               </EditorToolbar>
            </RichEditor>
        )
    }
}

// minimalist toolbar rich editor
export class MinimalRichEditor extends RichEditorComponent{
    constructor(props){
        super(props);
    }

    componentDidMount(){
        this.editor=this.richEditor.editor;
        this.editorContainer=this.richEditor.editorContainer;
    }

    componentDidUpdate(){
        this.editor=this.richEditor.editor;
        this.editorContainer=this.richEditor.editorContainer;
    }

    onEditorFocus(event){
        this.toolbar.setFocus();
    }

    onEditorBlur(event){
        this.toolbar.removeFocus();
    }

    onToolbarHide(){
        super.onToolbarHide();
        this.toolbar.hide();
    }


    render(){
        var cls='single-toolbar no-min-height';
        if(this.props.disableSticky) cls+= ' sticky-disabled';
        if(this.props.cls) cls+=' ' + this.props.cls;
        return(
            <RichEditor 
               active={this.props.active} 
               content={this.props.content}  
               ref={(ref) => this.richEditor = ref} 
               onEditorFocus={this.onEditorFocus.bind(this)}
               onEditorBlur={this.onEditorBlur.bind(this)} 
               cls={cls} 
               onChange={this.props.onChange}
               >
               <EditorToolbar 
                   onToolbarActive={this.onToolbarActive.bind(this)} 
                   ref={(ref) => this.toolbar = ref} 
                   disableAlwaysVisible={this.props.disableAlwaysVisibleToolbar}
                >
                   <ToolbarMinimalButtonGroup 
                      onButtonClick={this.onButtonClick.bind(this)} 
                      onToolbarHide={this.onToolbarHide.bind(this)} 
                      onColorSelect={this.onColorSelect.bind(this)} 
                      addColors={this.props.addColors} 
                      onDialogAccept={this.onDialogAccept.bind(this)} 
                      onSaveSelection={this.onSaveSelection.bind(this)} 
                      onCreateLink={this.onCreateLink.bind(this)} 
                      onHtmlCheckedChange={this.onHtmlCheckedChange.bind(this)}
                    />
               </EditorToolbar>
            </RichEditor>
        )
    }
}

//minimal content editable
export class TinyEditable extends RawMarkupComponent{
    constructor(props){
        super(props)
    }

    componentDidMount(){
        if(this.props.active) this.body.setAttribute('contenteditable',true);
    }

    componentDidUpdate(){
        if(this.props.active) this.body.setAttribute('contenteditable',true);
        else this.body.removeAttribute('contenteditable');
    }

    onChange(event){
       if(this.props.onChange) {
        var html=this.body.innerHTML;
        html=Word.clean(html);
        this.props.onChange(html);
       }
    }

    getContent(){
        return this.body.innerHTML;
    }

    render(){
        if(this.props.active){
            return(
               <div className={this.props.cls} ref={(ref) => this.body = ref} onBlur={this.onChange.bind(this)} dangerouslySetInnerHTML={this.rawMarkup(this.props.content)}></div>
            );
        }else{
            return(
              <div className={this.props.cls} ref={(ref) => this.body = ref} dangerouslySetInnerHTML={this.rawMarkup(this.props.content)}></div>
            );
        }
    }
}

export default {
    ContentPlaceholder,
    ContentEditable,
    RichEditor,
    RichEditorComponent,
    ContentRichEditor,
    TinyRichEditor,
    TinyEditable,
    MinimalRichEditor
}

